/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNotificationNumbers } from "../../../hooks/useNotification.Numbers";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { useBitacoraNotificaciones } from "../hooks/useBitacoraNotificaciones";
import { useCultivo } from "../hooks/useCultivo";

export const ProyeccionDiariaFilter = ({
  values,
  handleChange,
  setFieldValue,
  loading,
  onSubmit,
  idNotificacion,
  mensaje,
  refrechNotificationOnSend,
}) => {
  const { getCultivo } = useCultivo();
  const { getNotificationNumbers } = useNotificationNumbers();
  const { saveNotificacion } = useBitacoraNotificaciones();
  const [cultivoOptions, setCultivoOptions] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const user = localStorage.getItem("@usuario");
  const json_user = JSON.parse(user);

  const sendNotifications = () => {
    if (numbers.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Favor de comunicarlo con el equipo de desarrollo",
        text: "No hay numeros a donde mandar notificaciones",
      });
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Enviar notificación",
      text: "¿Está seguro de que desea enviar la notificación?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        await numbers.reduce(async (promise, current) => {
          await promise;
          var data = JSON.stringify({
            token: process.env.REACT_APP_NOTIFICATION_TOKEN,
            to: current.number,
            body: `✉️ Notificación automática: 

Les informamos que ${json_user.nombre} ${
              json_user.apellido
            } ha ${mensaje} la proyección de cosecha del dia 📅 ${moment(
              values.fecha
            ).format("DD/MM/YYYY")} del campo ${localStorage.getItem(
              "Campo"
            )} y se encuentra disponible en la plataforma, favor de verificarlo ✅`,
          });

          var config = {
            method: "post",
            url: `https://api.ultramsg.com/${process.env.REACT_APP_NOTIFICATION_INSTANCE}/messages/chat`,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          try {
            await axios(config);
          } catch (error) {
            Swal.showValidationMessage(
              `Error - Favor de comunicarlo con el equipo de desarrollo`
            );
            return;
          }
        }, Promise.resolve());
      },
      allowOutsideClick: () => {
        return !Swal.isLoading();
      },
      backdrop: true,
    }).then(async (res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Notificaciones enviadas",
          timer: 1500,
        });
        await saveNotificacion(values.fecha, 1);
        refrechNotificationOnSend();
      }
    });
  };

  useEffect(() => {
    const getNumbers = async () => {
      const response = await getNotificationNumbers("diaria");
      setNumbers(response);
    };
    getNumbers();
  }, []);

  useEffect(() => {
    const getCultivoList = async () => {
      const response = await getCultivo();
      setCultivoOptions(response);
      if (response && response.length === 1) {
        setFieldValue("cultivo", response[0].idcultivo);
      }
    };
    getCultivoList();
  }, []);

  return (
    <div className="row">
      <div
        className="col-md-4 col-sm-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label>Cultivo</label>
        <select
          disabled={cultivoOptions.length === 1}
          value={values.cultivo}
          onChange={handleChange}
          name="cultivo"
          className="form-control"
        >
          <option value="">Seleccionar...</option>
          {cultivoOptions.map((item) => (
            <option value={item.idcultivo} key={item.idcultivo}>
              {item.cultivo}
            </option>
          ))}
        </select>
      </div>
      <div
        className="col-md-4 col-sm-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label>Fecha</label>
        <input
          type="date"
          value={values.fecha}
          onChange={handleChange}
          name="fecha"
          className="form-control"
        />
      </div>
      <div className="col-md-4 col-sm-12">
        <button
          className="btn btn-success mt-4"
          disabled={loading.get || loading.post}
          onClick={onSubmit}
        >
          {loading.get || loading.post ? (
            <FontAwesomeIcon icon="fas fa-spinner" spin />
          ) : (
            "Guardar"
          )}
        </button>{" "}
        {idNotificacion && (
          <button
            className="btn btn-outline-success mt-4"
            onClick={sendNotifications}
          >
            <FontAwesomeIcon icon="fab fa-whatsapp" />
          </button>
        )}
      </div>
    </div>
  );
};
